// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import cleanupUploadData from "@insite/client-framework/Store/Components/OrderUpload/Handlers/CleanupUploadData";
import setContinueUpload from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetContinueUpload";
import setFailedToLoadInventory from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetFailedToLoadInventory";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import setErrorsModalIsOpen from "@store/Framework/Store/Greif/Components/GreifOrderUpload/Handlers/SetErrorsModalIsOpen";
import setIsBadFile from "@store/Framework/Store/Greif/Components/GreifOrderUpload/Handlers/SetIsBadFile";
import setUploadLimitExceeded from "@store/Framework/Store/Greif/Components/GreifOrderUpload/Handlers/SetUploadLimitExceeded";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import FlexWrapper, { FlexWrapperPresentationProps } from "@store/Library/Components/Toolkit/FlexWrapper";
import setErrorMessage from "@store/Framework/Store/Greif/Components/GreifOrderUpload/Handlers/SetErrorMessage";
import { css } from "styled-components";

interface OwnProps {
    uploadErrorText: React.ReactNode;
    rowsLimitExceededText: React.ReactNode;
    extendedStyles?: OrderUploadErrorsModalStyles;
}

const mapStateToProps = (state: ApplicationState) => ({
    errorsModalIsOpen: state.greif.components.greifOrderUpload.errorsModalIsOpen,
    isBadFile: state.greif.components.greifOrderUpload.isBadFile,
    uploadLimitExceeded: state.greif.components.greifOrderUpload.uploadLimitExceeded,
    errorMessage: state.greif.components.greifOrderUpload.errorMessage,
});

const mapDispatchToProps = {
    setErrorsModalIsOpen,
    cleanupUploadData,
    setIsBadFile,
    setFailedToLoadInventory,
    setUploadLimitExceeded,
    setContinueUpload,
    setErrorMessage,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderUploadErrorsModalStyles {
    modal?: ModalPresentationProps;
    errorMessagesModal?: ModalPresentationProps;
    uploadErrorText?: TypographyPresentationProps;
    rowsLimitExceededErrorText?: TypographyPresentationProps;
    continueButton?: ButtonPresentationProps;
    buttonsWrapper?: InjectableCss;
    continueUploadButton?: ButtonPresentationProps;
    wrapper?: InjectableCss;
    errorsWrapper?: FlexWrapperPresentationProps;
}

export const orderUploadErrorsModalStyles: OrderUploadErrorsModalStyles = {
    modal: { sizeVariant: "medium" },
    errorMessagesModal: { sizeVariant: "small" },
    continueButton: { variant: "primary" },
    continueUploadButton: { variant: "primary" },
    errorsWrapper: {
        extendedStyles: {
            content: {
                css: css`
                    flex-direction: column;
                `,
            },
        },
    },
};

const OrderUploadErrorsModal: React.FC<Props> = ({
    errorsModalIsOpen,
    isBadFile,
    uploadLimitExceeded,
    errorMessage,
    setErrorsModalIsOpen,
    cleanupUploadData,
    setIsBadFile,
    setFailedToLoadInventory,
    setUploadLimitExceeded,
    setErrorMessage,
    uploadErrorText,
    rowsLimitExceededText,
    extendedStyles,
}) => {
    const [styles] = React.useState(() => mergeToNew(orderUploadErrorsModalStyles, extendedStyles));
    const [uploadCanceled, setUploadCanceled] = useState(false);

    const closeModal = () => {
        setErrorsModalIsOpen({ errorsModalIsOpen: false });
        setErrorMessage({ errorMessage: "" });
    };

    const modalOnAfterCloseHandler = () => {
        setIsBadFile({ isBadFile: false });
        setFailedToLoadInventory({ failedToLoadInventory: false });
        setUploadLimitExceeded({ uploadLimitExceeded: false });
        if (uploadCanceled) {
            cleanupUploadData();
            setUploadCanceled(false);
        }
    };

    return (
        <Modal
            {...(isBadFile || uploadLimitExceeded || errorMessage ? styles.errorMessagesModal : styles.modal)}
            headline={translate("Upload Error")}
            isOpen={errorsModalIsOpen}
            handleClose={closeModal}
            onAfterClose={modalOnAfterCloseHandler}
            data-test-selector="orderUpload_UploadError"
        >
            <>
                <FlexWrapper {...styles.errorsWrapper}>
                    {errorMessage && <Typography>{errorMessage}</Typography>}
                    {isBadFile && <Typography>{uploadErrorText}</Typography>}
                    {uploadLimitExceeded && <Typography>{rowsLimitExceededText}</Typography>}
                </FlexWrapper>
                <FormActions>
                    <Button
                        {...styles.continueButton}
                        onClick={closeModal}
                        data-test-selector="greifOrderUpload_UploadError_Continue"
                    >
                        {translate("Continue")}
                    </Button>
                </FormActions>
            </>
        </Modal>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderUploadErrorsModal);
